import debounce from 'lodash.debounce';
export const listenForViewportChange = (callback)=>{
    const viewport = window.visualViewport ?? window;
    const debouncedCallback = debounce(callback, 200);
    const addListener = ()=>{
        viewport.addEventListener('resize', debouncedCallback);
        window.addEventListener('resize', debouncedCallback);
    };
    const removeListener = ()=>{
        viewport.removeEventListener('resize', debouncedCallback);
        window.removeEventListener('resize', debouncedCallback);
        debouncedCallback.cancel?.();
    };
    return {
        addListener,
        removeListener
    };
};

//# sourceMappingURL=listenForViewportChange.js.map